import { ButtonOwnProps } from "@mui/material";

/**
 * We can add more variants as needed (i.e. secondary, error, text, gradient, etc)
 */
export enum ButtonVariant {
  PRIMARY = "primary",
  OUTLINED = "outlined",
  OUTLINED_BLACK = "outlined--black",
  BLACK_OUTLINED_BUTTON_BLACK_HOVER = "black-outlined--black",
  GRADIENT = "gradient",
  UNSTYLED = "unstyled",
  GHOST = "ghost",
  TERTIARY = "tertiary",
  ACTIVE = "active",
  SUCCESS = "success",
  ERROR = "error",
  TEXT = "text",
  DISABLED = "disabled",
  ICON = "icon",
  BLACK = "black",
  DELETE = "delete",
}

export const muiVariant: Record<ButtonVariant, ButtonOwnProps["variant"]> = {
  [ButtonVariant.PRIMARY]: "contained",
  [ButtonVariant.OUTLINED]: "outlined",
  [ButtonVariant.OUTLINED_BLACK]: "outlined",
  [ButtonVariant.BLACK_OUTLINED_BUTTON_BLACK_HOVER]: "outlined",
  [ButtonVariant.GRADIENT]: "contained",
  [ButtonVariant.UNSTYLED]: "text",
  [ButtonVariant.GHOST]: "text",
  [ButtonVariant.TERTIARY]: "text",
  [ButtonVariant.ACTIVE]: "text",
  [ButtonVariant.SUCCESS]: "contained",
  [ButtonVariant.ERROR]: "contained",
  [ButtonVariant.TEXT]: "text",
  [ButtonVariant.DISABLED]: "text",
  [ButtonVariant.ICON]: "text",
  [ButtonVariant.BLACK]: "contained",
  [ButtonVariant.DELETE]: "contained",
};

export const muiColor: Record<ButtonVariant, ButtonOwnProps["color"]> = {
  [ButtonVariant.PRIMARY]: "primary",
  [ButtonVariant.OUTLINED]: "secondary",
  [ButtonVariant.OUTLINED_BLACK]: "secondary",
  [ButtonVariant.BLACK_OUTLINED_BUTTON_BLACK_HOVER]: "secondary",
  [ButtonVariant.GRADIENT]: "primary",
  [ButtonVariant.UNSTYLED]: "secondary",
  [ButtonVariant.GHOST]: "secondary",
  [ButtonVariant.TERTIARY]: "secondary",
  [ButtonVariant.ACTIVE]: "primary",
  [ButtonVariant.SUCCESS]: "success",
  [ButtonVariant.ERROR]: "error",
  [ButtonVariant.TEXT]: "secondary",
  [ButtonVariant.DISABLED]: "primary",
  [ButtonVariant.ICON]: "secondary",
  [ButtonVariant.BLACK]: "secondary",
  [ButtonVariant.DELETE]: "secondary",
};

export const buttonStyle: Record<ButtonVariant, string> = {
  [ButtonVariant.PRIMARY]: "button-primary",
  [ButtonVariant.OUTLINED]: "button-outlined",
  [ButtonVariant.OUTLINED_BLACK]: "button-outlined--black",
  [ButtonVariant.BLACK_OUTLINED_BUTTON_BLACK_HOVER]:
    "button-black-outlined--black",
  [ButtonVariant.GRADIENT]: "button-gradient",
  [ButtonVariant.UNSTYLED]: "button-unstyled",
  [ButtonVariant.GHOST]: "button-ghost",
  [ButtonVariant.TERTIARY]: "button-tertiary",
  [ButtonVariant.ACTIVE]: "button-active",
  [ButtonVariant.SUCCESS]: "button-success",
  [ButtonVariant.ERROR]: "button-error",
  [ButtonVariant.TEXT]: "button-text",
  [ButtonVariant.DISABLED]: "button-primary--disabled",
  [ButtonVariant.ICON]: "button-icon",
  [ButtonVariant.BLACK]: "button-black",
  [ButtonVariant.DELETE]: "button-delete",
};

export const buttonStyleDisabled: Record<ButtonVariant, string> = {
  [ButtonVariant.PRIMARY]: "button-primary--disabled",
  [ButtonVariant.OUTLINED]: "button-outlined--disabled",
  [ButtonVariant.OUTLINED_BLACK]: "button-outlined--black--disabled",
  [ButtonVariant.BLACK_OUTLINED_BUTTON_BLACK_HOVER]:
    "button-black-outlined--black--disabled",
  [ButtonVariant.GRADIENT]: "button-gradient--disabled",
  [ButtonVariant.UNSTYLED]: "button-unstyled--disabled",
  [ButtonVariant.GHOST]: "button-ghost--disabled",
  [ButtonVariant.TERTIARY]: "button-tertiary--disabled",
  [ButtonVariant.ACTIVE]: "button-active--disabled",
  [ButtonVariant.SUCCESS]: "button-success--disabled",
  [ButtonVariant.ERROR]: "button-error--disabled",
  [ButtonVariant.TEXT]: "button-text",
  [ButtonVariant.DISABLED]: "button-primary--disabled",
  [ButtonVariant.ICON]: "button-icon--disabled",
  [ButtonVariant.BLACK]: "button-black--disabled",
  [ButtonVariant.DELETE]: "button-delete--disabled",
};
